module.exports = __webpack_public_path__ + "img/logo-dark.4a9a067.svg";